import { render, staticRenderFns } from "./BtClickableTable.vue?vue&type=template&id=3d95ebf1&"
import script from "./BtClickableTable.vue?vue&type=script&lang=js&"
export * from "./BtClickableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports